import React from 'react';
import { Tooltip } from "@curves/ui-base";
import { PrivacyDataToggleButton } from '@icoach/components';

const SingleActionPrivacyDataToggle = ({ isRevealed, onToggle }) => {
    return (
        <Tooltip title={isRevealed ? '隱蔽資料' : '顯示完整資料'}>
            <PrivacyDataToggleButton isRevealed={isRevealed} onToggle={onToggle} />
        </Tooltip>
    );
};

export default SingleActionPrivacyDataToggle;
